import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TravelEvents } from 'src/app/Models/MisEventos/travelEvents';
import { Coordinate } from 'src/app/Models/MisViajes/Coordinate';

@Component({
  selector: 'app-detalle-eventos',
  templateUrl: './detalle-eventos.component.html',
  styleUrls: ['./detalle-eventos.component.css']
})
export class DetalleEventosComponent implements OnInit {
  $: any;
  @Input()
  events: Array<TravelEvents>;
  @Output()
  travelEventsEmit = new EventEmitter<TravelEvents>();
  latNum: number;
  lonNum: number;

  dtOptions: DataTables.Settings = {};

  constructor() {
   }

  ngOnInit(): void{
    this.dtOptions = {
      language: {
        lengthMenu: 'Mostrar _MENU_ elementos',
        info: 'Resultados _PAGE_ de _PAGES_',
        search: 'Buscar',
        paginate: {
          first: 'Primero',
          last: 'Ultimo',
          previous: 'Anterior',
          next: 'Siguiente',
        }
      },
      columns: [{
        title: 'Tipo de evento',
        data: 'eventType'
      }, {
        title: 'Fecha y hora',
        data: 'timeStamp'
      }, {
        title: 'Duración',
        data: 'duration'
      }, {
        title: 'Descripción',
        data: 'description'
      }, {
        title: 'lat',
        data: 'lat'
      }, {
        title: 'lon',
        data: 'lon'
      }],
      rowCallback: (row: Node, data: any[]) => {
        $('td', row).unbind('click');
        $('td', row).bind('click', () => {
          this.SendCoordinatesToMap(data);
        });
        return row;
      }
    };
  }
  SendCoordinatesToMap(info: any): void {
    this.latNum = +info.lat;
    this.lonNum = +info.lon;
    this.travelEventsEmit.emit({eventType: info.eventType, timeStamp: info.timeStamp, duration:
      info.duration, description: info.description, lat: this.latNum, lon: this.lonNum});
  }
}
